module.exports = __webpack_public_path__ + "img/pdf.6e030e83.svg";